import { Button } from "@fluentui/react-components";
import { IPopupActionFooterProps } from "./PopupActionFooter.types";
import { useStyles } from "./PopupActionFooter.styles";

export const PopupActionFooter = ({
  onApply,
  onCancel,
  isApplyDisabled = false,
}: IPopupActionFooterProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.footer}>
      <Button size="medium" appearance="subtle" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        size="medium"
        appearance="primary"
        onClick={onApply}
        disabled={isApplyDisabled}
      >
        Apply
      </Button>
    </div>
  );
};
